module.exports = __webpack_public_path__ + "img/img2.9d4ac277.jpg";